var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "d-flex align-center", attrs: { cols: "12" } },
            [
              _c("canvas", { attrs: { id: _vm.id, height: "300" } }),
              _vm._v(" "),
              !_vm.mediaMode
                ? _c(
                    "div",
                    {
                      staticClass: "logo",
                      class: { "pt-5": _vm.$vuetify.breakpoint.smAndDown },
                    },
                    [
                      _c("v-img", {
                        attrs: {
                          src: require(`@/assets/img/${
                            _vm.$vuetify.theme.dark
                              ? "driblab_white.png"
                              : "driblab_color.png"
                          }`),
                          "max-width": _vm.$vuetify.breakpoint.smAndDown
                            ? "75px"
                            : "125px",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }